import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { TrendingUp, CheckCircle, Clock } from 'lucide-react';
import ProfilePicture from '@/components/ProfilePicture';
import { getMonthOptions, formatMonth } from './useContributorAdmin';

const PointsSummary = ({ 
  contributors, 
  selectedMonth, 
  setSelectedMonth,
  onAdjustPoints 
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5" />
          Monthly Points Summary - {formatMonth(selectedMonth)}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Select value={selectedMonth} onValueChange={setSelectedMonth}>
            <SelectTrigger className="w-48">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {getMonthOptions().map(month => (
                <SelectItem key={month} value={month}>
                  {formatMonth(month)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="text-left py-2 px-4">Contributor</th>
                  <th className="text-center py-2 px-4">Points</th>
                  <th className="text-center py-2 px-4">Status</th>
                  <th className="text-right py-2 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {contributors
                  .filter(c => c.is_active)
                  .sort((a, b) => (b.current_month_points || 0) - (a.current_month_points || 0))
                  .map(contributor => (
                    <tr key={contributor.id} className="border-b border-gray-800">
                      <td className="py-3 px-4">
                        <div className="flex items-center gap-3">
                          <ProfilePicture src={contributor.user?.profile_picture} size="sm" />
                          <span>{contributor.user?.full_name}</span>
                        </div>
                      </td>
                      <td className="text-center py-3 px-4">
                        <span className="text-xl font-bold text-cyan-400">
                          {contributor.current_month_points || 0}
                        </span>
                      </td>
                      <td className="text-center py-3 px-4">
                        {contributor.is_eligible ? (
                          <Badge className="bg-green-600">
                            <CheckCircle className="w-3 h-3 mr-1" />
                            Eligible
                          </Badge>
                        ) : (
                          <Badge variant="secondary">
                            <Clock className="w-3 h-3 mr-1" />
                            {100 - (contributor.current_month_points || 0)} pts needed
                          </Badge>
                        )}
                      </td>
                      <td className="text-right py-3 px-4">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => onAdjustPoints(contributor)}
                        >
                          Adjust
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PointsSummary;
